/** @jsx jsx */
import React from "react"
import NotificationSystem from "react-notification-system"
import { jsx } from 'theme-ui'
import style from "../components/NotificationStyles"
import Coupons from "../components/Sections/Coupons"
import Footer from "../components/Sections/Footer"
import Gallery from "../components/Sections/Gallery"
import Header from "../components/Sections/Header"
import Hero from "../components/Sections/Hero"
import Menu from "../components/Sections/Menu"
import OrderOnline from "../components/Sections/Orderonline"
import OurStory from "../components/Sections/OurStory"
import SEO from '../components/seo'
import Testimonials from "../components/Sections/Testimonials"
import "./reset.css"

export default class Home extends React.Component {
  notificationSystem = React.createRef();

  addNotification = event => {
    const notification = this.notificationSystem.current;
    console.log(style);
    notification.addNotification({
      position: 'br',
      autoDismiss: 0,
      action: {
        label: 'OK, I got this',
      },
      title: 'COVID-19 Restrictions',
      message: 'Sometimes restaurants need to have a major announcement/alert on their website -- e.g., new COVID-19 policies, unexpected closing, etc. ',
      level: 'info'
    });
  };

  componentDidMount() {
    setTimeout(() => {
      this.addNotification()
    }, 3000);
  }

  render() {
    return (
      <div sx={{
        overflow: 'hidden'
      }}>
        <SEO />
        <Header />
        <Hero id="home" raggedBottom />
        <Gallery id="gallery" />
        <OurStory id="ourstory" />
        <Menu id="menu" raggedTop raggedBottom raggedTopColor="neutral100" raggedBottomColor="neutral100" />
        <OrderOnline id="orderonline" hasOrnaments />
        <Testimonials id="reviews" hasOrnaments />
        <Coupons id="coupons" />
        <Footer id="footer" />
        <NotificationSystem ref={this.notificationSystem} style={style} />
      </div>
    )
  }
}
